import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { useAppStore } from 'stores/state';
import { FormField, Input } from '@wix/design-system';

export const CurrentPlatformStepInput: FC = () => {
  const { t } = useTranslation();

  const currentPlatformUrl = useAppStore((state) => state.currentPlatformUrl);
  const setCurrentPlatformUrl = useAppStore((state) => state.setCurrentPlatformUrl);

  return (
    <FormField label={t('current-platform-step.url-input.label')}>
      <Input
        placeholder={t('current-platform-step.url-input.placeholder')}
        onChange={(e) => setCurrentPlatformUrl(e.target.value)}
        value={currentPlatformUrl}
      />
    </FormField>
  );
};
